import { DocumentType, DocumentTypePlural } from '@/components/Document/types/document-type';
import contractNotes from '@/router/customers/contract-notes';
import creditNotes from '@/router/customers/credit-notes';
import deliveryNotes from '@/router/customers/delivery-notes';
import invoices from '@/router/customers/invoices';
import quotes from '@/router/customers/quotes';
import recurringInvoices from '@/router/customers/recurring-invoices';
import templates from '@/router/customers/templates';
import type { RouteConfig } from 'vue-router';

const Customers = () => import('@/pages/customers/Customers.vue');
const InvoiceForm = () => import('@/components/invoice/InvoiceForm.vue');
const JsonImport = () => import('@/pages/customers/JsonImport.vue');
const PassThroughKeyed = () => import('@/views/PassThroughKeyed.vue');

const UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export default {
  path: '/customers',
  name: 'customers',
  component: Customers,
  redirect: { name: 'quotes-list' },
  children: [
    {
      path: 'json-import',
      name: 'document-json-import',
      component: JsonImport,
    },

    {
      path: ':typePlural',
      component: PassThroughKeyed,
      children: [
        {
          path: 'create/:addressId?',
          name: 'invoices-create',
          component: InvoiceForm,
          beforeEnter(to, from, next) {
            if (!to.meta) {
              to.meta = {};
            }

            const foundTypeEntry = Object.entries(DocumentTypePlural)
              .find((entry) => entry[1] === to.params.typePlural);

            const documentType = foundTypeEntry ? foundTypeEntry[0] : DocumentType.INVOICE;

            to.meta.title = `create_${documentType}`;
            next();
          },
        },
        {
          path: 'edit/:id',
          name: 'invoices-edit',
          component: InvoiceForm,
          meta: {
            paymentListType: 'invoice',
          },
          beforeEnter(to, from, next) {
            if (!to.meta) {
              to.meta = {};
            }

            const foundTypeEntry = Object.entries(DocumentTypePlural)
              .find((entry) => entry[1] === to.params.typePlural);

            const documentType = foundTypeEntry ? foundTypeEntry[0] : DocumentType.INVOICE;

            to.meta.title = `edit_${documentType}`;
            next();
          },
        },
        {
          path: `:typeSingular(\\D+)/:documentUuid(${UUID})`,
          props: true,
          redirect: (to) => ({
            path: `/v3/customers/${to.params.typePlural}/${to.params.typeSingular}/${to.params.documentUuid}`,
          }),
        },
      ],
    },

    ...quotes,
    ...contractNotes,
    ...deliveryNotes,
    ...invoices,
    ...creditNotes,
    ...recurringInvoices,
    ...templates,
  ],
} as RouteConfig;
